const PADDING_TOP = 'padding-top';
const PADDING_BOTTOM = 'padding-bottom';
const PADDING_LEFT = 'padding-left';
const PADDING_RIGHT = 'padding-right';

/**
 * Effectively `Element.clientWidth` without counting padding.
 * @param el {Element}
 * @returns {number} The width of an Element's content.
 */
export const contentWidth = el => {
  const computedStyle = window.getComputedStyle(el);
  const horizontalPadding = [PADDING_LEFT, PADDING_RIGHT].reduce(
    (padding, styleName) => parseInt(computedStyle[styleName], 10),
    0
  );

  return el.getBoundingClientRect().width - horizontalPadding;
};

/**
 * Effectively `Element.clientHeight` without counting padding.
 * @param el {Element}
 * @returns {number} The height of an Element's content.
 */
export const contentHeight = el => {
  const computedStyle = window.getComputedStyle(el);
  const verticalPadding = [PADDING_TOP, PADDING_BOTTOM].reduce(
    (padding, styleName) => parseInt(computedStyle[styleName], 10),
    0
  );

  return el.getBoundingClientRect().height - verticalPadding;
};
